export interface AppConfig {
  auth: {
    clientId: string;
    authority: string;
  };
  token: {
    scopes: string[];
  };
}

export async function load(): Promise<AppConfig> {
  const response = await fetch("/config.json");
  if (!response.ok) {
    throw new Error(response.statusText);
  }

  return response.json() as Promise<AppConfig>;
}
